<div class="ratings" *ngIf="score > 0">
    <div class="row" style="padding-left: 15px;">
        <div *ngFor="let item of starsFull">
            <i class="fas fa-star cm-tx-color-11" [ngClass]="{'alternativeColor': useAlternativeColor}"></i>
        </div>
        <div *ngFor="let item of starsHalf">
            <i class="fas fa-star-half-alt cm-tx-color-11" [ngClass]="{'alternativeColor': useAlternativeColor}"></i>
        </div>
        <div *ngFor="let item of starsEmpty">
            <i class="far fa-star cm-tx-color-11" [ngClass]="{'alternativeColor': useAlternativeColor}"></i>
        </div>
    </div>
</div>